import {
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";

const EditNameModal = ({
  data,
  onClose,
  isLoading = false,
  isOpen = false,
  onSave,
}: {
  onClose: () => void;
  isOpen: boolean;
  data: {
    name?: string;
    subtitle?: string;
    age_restriction?: string;
  };
  onSave: (
    props: Partial<{
      name: string;
      subtitle: string;
      age_restriction: string;
      age_restrictions_select: string;
      age_restrictions_input: string;
    }>
  ) => Promise<void>;
  isLoading: boolean;
}) => {
  const {
    register,
    handleSubmit,
    formState: { dirtyFields },
    watch,
  } = useForm({
    mode: "all",
    criteriaMode: "all",
    reValidateMode: "onBlur",
    values: {
      name: data.name || "",
      subtitle: data.subtitle || "",
      age_restrictions_select: [undefined, "", "18+", "21+"].includes(
        data.age_restriction
      )
        ? data.age_restriction
        : "custom",
      age_restrictions_input: ![undefined, "", "18+", "21+"].includes(
        data.age_restriction
      )
        ? data.age_restriction
        : "",
    },
  });

  const _onSave = (submittedData) => {
    const payload = Object.keys(dirtyFields).reduce((acc, key) => {
      acc[key] = submittedData[key];
      return acc;
    }, {} as any);

    if (
      dirtyFields.age_restrictions_select ||
      dirtyFields.age_restrictions_input
    ) {
      if (submittedData.age_restrictions_select !== "custom") {
        payload.age_restriction = submittedData.age_restrictions_select;
      } else {
        payload.age_restriction = submittedData.age_restrictions_input;
      }
      delete payload.age_restrictions_select;
      delete payload.age_restrictions_input;
    }

    onSave(payload);
  };

  return (
    <Modal
      size={"3xl"}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Stack py={4} spacing={8}>
            <Stack spacing={1}>
              <Text fontWeight={"700"} fontSize={"lg"}>
                Event Name
              </Text>
              <Input isDisabled={isLoading} {...register("name")} />
            </Stack>
            <Stack spacing={2}>
              <Stack spacing={0}>
                <HStack>
                  <Text fontWeight={"600"} fontSize={"lg"}>
                    Event Subtitle
                  </Text>
                  <Text fontWeight={"400"}>(Optional)</Text>
                </HStack>

                <Text fontSize={"sm"} color={"gray.500"}>
                  Shown below the event name
                </Text>
              </Stack>
              <Input
                placeholder="Subtitle"
                isDisabled={isLoading}
                {...register("subtitle")}
              />
            </Stack>
            <Stack spacing={1} flex="3" w="100%">
              <Text fontWeight={"medium"}>Age Limit (Optional)</Text>
              <Stack direction={["column", null, "row"]} spacing={2}>
                <Select
                  name="age_restrictions_select"
                  {...register("age_restrictions_select")}
                  isDisabled={isLoading}
                  w={["100%", null, "120px"]}
                >
                  <option value="">None</option>
                  <option value="18+">18+</option>
                  <option value="21+">21+</option>
                  <option value="custom">Custom...</option>
                </Select>
                {watch("age_restrictions_select") === "custom" && (
                  <Input
                    name="age_restrictions_input"
                    {...register("age_restrictions_input")}
                    flex="1.8"
                    minH="40px"
                    placeholder="e.g. 16+ w/ guardian"
                    isDisabled={isLoading}
                  />
                )}
              </Stack>
            </Stack>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={isLoading}
            onClick={() => {
              onClose();
            }}
            mr="4"
          >
            Cancel
          </Button>
          <Button
            color="white"
            bg="green.500"
            isLoading={isLoading}
            onClick={handleSubmit(_onSave)}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditNameModal;
